import { autoinject } from 'aurelia-framework';
import { Appender } from 'aurelia-logging';
import { NotificationService, NotificationType } from '../components/notifications/notification-service';

@autoinject
export class NotificationErrorLogger implements Appender {
	constructor(private notificationService: NotificationService) {
	}

	debug(logger: object, ...rest: any[]): void {
		// no-op
	}

	info(logger: object, ...rest: any[]): void {
		// no-op
	}

	warn(logger: object, ...rest: any[]): void {
		// no-op
	}

	error(logger: object, ...rest: any[]): void {
		if (!rest || rest.length < 1) {
			return;
		}

		const error = rest[0];

		this.notificationService.push(error, null, NotificationType.Error);
	}
}
